var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlowUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    rx: 8,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 141C127.121 141 141 127.121 141 110C141 92.8792 127.121 79 110 79C92.8792 79 79 92.8792 79 110C79 127.121 92.8792 141 110 141Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.786 116.152C108.951 114.697 112.77 108.519 111.315 102.354C109.859 96.1884 103.682 92.37 97.5166 93.8252C91.3512 95.2803 87.5329 101.458 88.988 107.623C90.4432 113.789 96.6208 117.607 102.786 116.152Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.48 126.05C86.38 123.91 89.96 122.65 93.84 122.65H106.12C107 122.65 107.86 122.71 108.71 122.85C113.88 123.61 118.31 126.64 120.97 130.9C122.27 132.99 123.14 135.38 123.46 137.93",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.94 109.44C128.121 109.44 131.51 106.051 131.51 101.87C131.51 97.6893 128.121 94.3 123.94 94.3C119.759 94.3 116.37 97.6893 116.37 101.87C116.37 106.051 119.759 109.44 123.94 109.44Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.71 122.85C110.1 118.03 114.53 114.51 119.79 114.51H127.88C132.78 114.51 136.97 117.57 138.64 121.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowUsers);
export default __webpack_public_path__ + "static/media/icon-flow-users.5b2286ba9bda7c741256ff9848bcac7b.svg";
export { ForwardRef as ReactComponent };